(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.competitors.competitorsManagerService', []).service('competitorsManagerService', CompetitorsManagerService);

  CompetitorsManagerService.$inject = ['$http'];
  function CompetitorsManagerService($http) {
    this.http_ = $http;
  }

  CompetitorsManagerService.prototype.listCompetitors = function (locationId) {
    return this.http_.get('/admin/location/' + locationId + '/competitors');
  };

  CompetitorsManagerService.prototype.deleteCompetitor = function (locationId, competitorId) {
    return this.http_.delete('/v5/locations/' + locationId + '/competitors/' + competitorId)
  };

})();
